import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { AdminLogin } from "../components/admin/AdminLogin";
import { AdminShell } from "../components/admin/AdminShell";

export default function Admin() {
  const [status, setStatus] = useState("checking"); // checking | guest | authed

  useEffect(() => {
    api
      .get("/admin/me")
      .then(() => setStatus("authed"))
      .catch(() => setStatus("guest"));
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-[#050A15] flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-[#d4a840]/30 border-t-[#d4a840] animate-spin" />
      </div>
    );
  }

  if (status === "guest") {
    return <AdminLogin onLoggedIn={() => setStatus("authed")} />;
  }

  return <AdminShell onLoggedOut={() => setStatus("guest")} />;
}
